export const ProductType = {
    디지털자료: "디지털자료",
    교구: "교구",
    교재: "교재",
} as const;
